module.exports = __webpack_public_path__ + "static/media/header.c44d433c.png";